import * as axios from 'axios';
import { getAuthHeader } from '../utils';

export const upcomingCampusDrive = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-campus-drive-list`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const registeredCampusDrive = (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-registered-campus-drives?page=${page}&limit=${limit}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const registerForCampusDrive = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-register-campus-drive`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}




export const campusDriveStudentDetail = (otp) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh/campus-drive/verify/${otp}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const jobDriveRegistration = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh/job-drive/registration`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


